export class Enum{
    protected values:any[]=[];
    protected translator: IEnumTranslator;    

    constructor() {
    }
    getValues(){
        return this.values;
    }
    getValueStrings(){
        return this.values.map(x=>this.translator.GetString(x));
    }
    getValuesWithTheirStringValues(){
        return this.values.map(x=>{return {
            value:x,
            stringValue:this.translator.GetString(x)
        }});
    }
    translateValue(v){
        return this.translator.GetString(v);
    }
}
export interface IEnumTranslator{
    GetString(value);
}
